module.exports = __webpack_public_path__ + "img/exmRoom.48b4fa2d.png";